import { ContactInfo } from "./contact/ContactInfo";
import { ContactForm } from "./contact/ContactForm";

export default function Contact() {
  return (
    <section id="contact" className="relative bg-[#0A0A0A] py-20 lg:py-28 scroll-mt-16 overflow-hidden">
      <div className="absolute -left-40 bottom-0 w-[420px] h-[420px] rounded-full bg-[#FF6B00]/10 blur-[140px]" />
      <div className="container-x grid lg:grid-cols-2 gap-14 lg:gap-20">
        <ContactInfo />
        <ContactForm />
      </div>
    </section>
  );
}
